import { TipoUsuarioPerfilOpcionEnum } from "@/modules/escritorio/types/enums/TipoUsuario.enum"
import type { PerfilEntidad } from "../types/interfaces/user.interface";
import { storage } from "../utils/Const.utils";
import { StorageKeys } from "../types/enums/Storage.enum";
import { RolEnum } from "../types/enums/TipoRoles.enum";

export enum TipoUsuarioConsulta{
    /** 
     * persona fisica = datos de la entidad no existen 
    */
    PERSONA_FISICA = 'PERSONA_FISICA',
    /**
     * abogado|paralegal
    */
    ABOGADO_PARA_LEGAL = 'ABOGADO_PARA_LEGAL',
    /** 
     * administrador|ministerio publico
    */
    ADMIN_MINISTERIO_PUBLICO = 'ADMIN_MINISTERIO_PUBLICO',
    /** 
     * NO DISPONIBLE
    */
    ND = 'NO_DISPONIBLE',
}

export const useTipoUsuarioPerfilConsulta = (tipoUsuario: TipoUsuarioPerfilOpcionEnum) => {

    const perfil : PerfilEntidad = storage.get(StorageKeys.PERFIL);

    let tipoUsuarioConsulta : TipoUsuarioConsulta;

    if ([TipoUsuarioPerfilOpcionEnum.CIUDADANO, TipoUsuarioPerfilOpcionEnum.ENTIDAD].includes(tipoUsuario) && perfil?.infoEntidad === null) {

        tipoUsuarioConsulta = TipoUsuarioConsulta.PERSONA_FISICA

    } else if (perfil?.infoEntidad && [RolEnum.Abogado, RolEnum.Paralegal].includes(perfil?.infoEntidad?.relacion?.idRol!)) {

        tipoUsuarioConsulta = TipoUsuarioConsulta.ABOGADO_PARA_LEGAL

    } else if (perfil?.infoEntidad && [RolEnum.Administrador, RolEnum.MinisterioPublico].includes(perfil?.infoEntidad?.relacion?.idRol!)) {

        tipoUsuarioConsulta = TipoUsuarioConsulta.ADMIN_MINISTERIO_PUBLICO

    } else {

        tipoUsuarioConsulta = TipoUsuarioConsulta.ND
        
    }

    return{
        tipoUsuarioConsulta
    }
}